// extracted by mini-css-extract-plugin
export var addToCartButton = "_pw-b";
export var arrowButtonContainer = "_pw-9";
export var arrowButtonIcon = "_pw-a";
export var carouselArrowButton = "_pw-6";
export var carouselElementContainer = "_pw-1";
export var galleryThumbnail = "_pw-d";
export var galleryThumbnailImage = "_pw-e";
export var left = "_pw-7";
export var productDisplayCarouselContainer = "_pw-0";
export var productTileContainer = "_pw-2";
export var productTileImage = "_pw-4";
export var productTileImageContainer = "_pw-3";
export var productTileTitle = "_pw-5";
export var right = "_pw-8";
export var sliderOverflow = "_pw-c";